import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import jwt_decode from 'jwt-decode';
import routes from '../router/routes'
import { logoutUser } from '../store/appStore/actions/userActions';
// public access
// import queryString from 'query-string';

import Login from './Auth/Login';
// import * as palette from '../style/Variables';

import ResponseInterceptor from '../utils/ResponseInterceptor';
import NavigationRoot from './NavigationRoot';
import ComponentRenderRoot from './ComponentRenderRoot'
import ScreenLoading from '../components/loader/ScreenLoading';
import * as Styled from "./style";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Public components
// import SurveyJPTNG from './Public/SurveyHCJ_JPT_NG';
// import SurveyP2NG from './Public/SurveyHCJ_P2_NG';
// import SurveyWithTime from './Public/SurveyWithTime';
// import SurveyWithTimePRV from './Public/SurveyWithTimePRV';
// import SurveyGEO from './Public/SurveyHCJ_GEO';
// import SurveyPRO from './Public/SurveyHCJ_PRO';


const AppRoot = () => {
    const isAuthenticated = useSelector(state => state.user.isAuthenticated)
    const token = useSelector(state => state.user.token)
    const loading = useSelector(state => state.app.loading)
    const dispatch = useDispatch()

    // The session is rehydrated from localStorage on load. If the stored JWT has
    // already expired, log out right away instead of showing a broken app whose
    // every request fails. Checked on load only; an expiry mid-session is still
    // handled by the response interceptor on the next request.
    useEffect(() => {
        if(!isAuthenticated) return
        if(!isTokenValid(token)) logoutUser(dispatch)
    }, [isAuthenticated, token, dispatch])
	// custom hook for filteredRoutes
    const filteredRoutes = useFilterRoutesByPermission()
	// custom hook for navigation style
    const navigationClass = useUserNavigationStyle()


	// public access condition
    let publicAccess = {state: false, survey: ''}
    // const { survey, uuid, department } = queryString.parse(window.location.search)

    // public redirect
    // if(survey === 'jpt-ng') publicAccess = {state: true, survey: 'jpt-ng'}
    // if(survey === 'p2-ng') publicAccess = {state: true, survey: 'p2-ng'}
    // if(survey === 'min') publicAccess = {state: true, survey: 'min'}
    // if(survey === 'geo') publicAccess = {state: true, survey: 'geo'}
    // if(survey === 'pro') publicAccess = {state: true, survey: 'pro'}
    // if(survey === 'prv') publicAccess = {state: true, survey: 'prv'}



    const appContent = (
        <div>
			<ResponseInterceptor />
            <NavigationRoot filteredRoutes={filteredRoutes} />
            <Styled.ContainerWrapper>
                <div className={navigationClass}>
                    <ComponentRenderRoot filteredRoutes={filteredRoutes} />
                </div>
            </Styled.ContainerWrapper>
        </div>
    )

    return(
        <div className="Application">
            {/* toast alert global settings */}
            <ToastContainer 
                autoClose={2500}
                closeButton={false}
                position={'top-right'}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
            />
            {loading && <ScreenLoading />}
            {/* master */}
            {!isAuthenticated && !publicAccess.state && <Login />}

            {/* hc survey - homepage */}
            {/* {!isAuthenticated && !publicAccess.state && <div style={{height: '100vh'}}><span style={{position: 'fixed', top: '45%', left: '50%'}}>{palette.home}</span></div>} */}
            {isAuthenticated && appContent}

            {/* Public */}
            {/* {!isAuthenticated && publicAccess.state && publicAccess.survey === 'jpt-ng' && <SurveyJPTNG uuid={uuid} />}
            {!isAuthenticated && publicAccess.state && publicAccess.survey === 'p2-ng' && <SurveyP2NG department={department} />} */}
            {/* {!isAuthenticated && publicAccess.state && publicAccess.survey === 'min' && <SurveyWithTime uuid={uuid} department={department} />}
            {!isAuthenticated && publicAccess.state && publicAccess.survey === 'prv' && <SurveyWithTimePRV uuid={uuid} department={department} />}
            {!isAuthenticated && publicAccess.state && publicAccess.survey === 'geo' && <SurveyGEO uuid={uuid} department={department} />}
            {!isAuthenticated && publicAccess.state && publicAccess.survey === 'pro' && <SurveyPRO uuid={uuid} department={department} />} */}
        </div>
    )
}

// true when the stored "Bearer <jwt>" token exists and has not expired
function isTokenValid(token) {
    if(typeof token !== 'string') return false
    const raw = token.startsWith('Bearer ') ? token.slice(7) : token
    try {
        const { exp } = jwt_decode(raw)
        return typeof exp === 'number' && exp * 1000 > Date.now()
    } catch (err) {
        return false
    }
}

// filter routes by permission hook
function useFilterRoutesByPermission() {
	const permissions = useSelector(state => state.user.permissions)
	return routes.filter(route => permissions.hasOwnProperty(route.permission) && permissions[route.permission])
}

function useUserNavigationStyle() {
	const user = useSelector(state => state.user)
    if(user.hasOwnProperty('Organization')) {
        if(user.Organization.hasOwnProperty('navigation')) {
            if(user.Organization.navigation === 'white') {
                return 'container_left'
            }
        }
    }
    return 'container'
}

export default AppRoot;